import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { money, statusClass } from "@/lib/utils-app";
import { useStores } from "@/lib/stores";
import { logError } from "@/lib/logger";

export default function AdminDashboard() {
  const { user } = useAuth();
  const { activeStore, activeStoreObj } = useStores();
  const [stats, setStats] = useState({ pending: 0, payments: 0, paid: 0, total: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const qs = activeStore ? `&store_id=${activeStore}` : "";
        const [p, pp] = await Promise.all([
          api.get(`/admin/service-orders?status=pending${qs}`),
          api.get(`/admin/service-orders?status=payment_pending${qs}`),
        ]);
        if (cancelled) return;
        const allDocs = [...p.data, ...pp.data];
        const paidSum = allDocs.filter(o => o.payment_status === "Pago").reduce((s,o) => s + (o.payment_amount || 0), 0);
        setStats({ pending: p.data.length, payments: pp.data.length, paid: paidSum, total: allDocs.length });
        setRecent(allDocs.slice(0, 6));
      } catch (err) {
        // 401 durante troca de sessão ou store selector — silêncio; auth.jsx redireciona quando necessário.
        if (err?.response?.status !== 401) {
          logError("[dashboard] load failed:", err);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [activeStore]);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-7xl">
      <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Visão geral{activeStoreObj ? ` · ${activeStoreObj.name}` : " · Todas as lojas"}</div>
      <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Painel</h1>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {[
          { l: "Serviços pendentes", v: stats.pending, mono: false },
          { l: "Pagamentos pendentes", v: stats.payments, mono: false },
          { l: "Total OS ativas", v: stats.total, mono: false },
          { l: "Recebido", v: money(stats.paid), mono: true },
        ].map((s) => (
          <div key={s.l} className="bg-white border border-neutral-200 rounded-xl p-5">
            <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold">{s.l}</div>
            <div className={`mt-2 text-3xl font-heading font-black ${s.mono ? "font-mono" : ""}`}>{s.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 bg-white border border-neutral-200 rounded-xl p-5">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-bold mb-3">Recentes</div>
        <div className="divide-y divide-neutral-100">
          {recent.map((o) => (
            <div key={o.os_code} className="flex items-center justify-between py-3">
              <div>
                <div className="font-mono font-bold">{o.os_code}</div>
                <div className="text-sm text-neutral-600">{o.customer_name} · {o.device_brand} {o.device_model}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className={statusClass(o.status)}>● {o.status}</span>
                <div className="font-mono">{money(o.total)}</div>
              </div>
            </div>
          ))}
          {recent.length === 0 && <div className="text-sm text-neutral-500 py-6 text-center">Sem OS ainda.</div>}
        </div>
      </div>
    </div>
  );
}
